import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["input"]
  static values = { delay: { type: Number, default: 250 } }
  
  connect() {
    // Search controller connected
    
    // Listener para cuando el turbo frame se actualiza
    document.addEventListener("turbo:frame-load", this.handleFrameLoad.bind(this))
    
    // Asegurar que el cursor esté al final al conectarse
    this.positionCursorAtEnd()
  }

  disconnect() {
    // Limpiar timeouts y listeners
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    document.removeEventListener("turbo:frame-load", this.handleFrameLoad.bind(this))
  }

  // Método principal de búsqueda con mejor UX
  search(event) {
    const query = event.target.value
    console.log("🔍 Search triggered:", query)
    
    // Guardar posición del cursor antes de buscar
    this.saveCursorPosition(event.target)
    
    // Clear previous timeout (debouncing)
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.hideSearchingIndicator()
    }
    
    // Si el campo está vacío, buscar inmediatamente
    if (query.trim() === '') {
      this.performSearch()
      return
    }
    
    // Mostrar indicador de búsqueda
    this.showSearchingIndicator()
    
    // Set new timeout con delay configurable
    this.timeout = setTimeout(() => {
      this.performSearch()
    }, this.delayValue)
  }

  // Realizar la búsqueda
  performSearch() {
    console.log("🚀 Performing search...")
    
    try {
      // Usar requestSubmit para mejor compatibilidad con Turbo
      if (this.element.requestSubmit) {
        this.element.requestSubmit()
      } else {
        this.element.submit()
      }
      console.log("✅ Search submitted")
    } catch (error) {
      console.error("❌ Search error:", error)
      this.hideSearchingIndicator()
    }
  }

  // Manejar cuando el turbo frame se actualiza
  handleFrameLoad(event) {
    // Solo actuar si es nuestro frame de vista
    if (event.target.id === "vista") {
      console.log("📄 Vista frame updated, restoring cursor")
      
      // Pequeño delay para asegurar que el DOM esté listo
      setTimeout(() => {
        this.restoreCursorPosition()
        this.hideSearchingIndicator()
      }, 50)
    }
  }

  // Guardar posición del cursor
  saveCursorPosition(input) {
    this.savedCursorPosition = input.selectionStart
    this.savedValue = input.value
    console.log("💾 Cursor saved at position:", this.savedCursorPosition)
  }

  // Restaurar posición del cursor
  restoreCursorPosition() {
    if (this.hasInputTarget && this.savedCursorPosition !== undefined) {
      // Enfocar el input
      this.inputTarget.focus()
      
      // Restaurar posición del cursor
      try {
        this.inputTarget.setSelectionRange(this.savedCursorPosition, this.savedCursorPosition)
        console.log("🎯 Cursor restored to position:", this.savedCursorPosition)
      } catch (error) {
        console.warn("⚠️ Could not restore cursor position:", error)
        this.positionCursorAtEnd()
      }
    }
  }

  // Posicionar cursor al final
  positionCursorAtEnd() {
    if (this.hasInputTarget) {
      const length = this.inputTarget.value.length
      this.inputTarget.setSelectionRange(length, length)
    }
  }

  // Mostrar indicador de búsqueda (opcional)
  showSearchingIndicator() {
    if (this.hasInputTarget) {
      this.inputTarget.style.background = '#f8f9fa'
      this.inputTarget.style.borderColor = '#6366f1'
    }
  }

  // Ocultar indicador de búsqueda
  hideSearchingIndicator() {
    if (this.hasInputTarget) {
      this.inputTarget.style.background = ''
      this.inputTarget.style.borderColor = ''
    }
  }
}